import { render } from "./PayoutOpsView.vue?vue&type=template&id=528b243a&scoped=true"
import script from "./PayoutOpsView.vue?vue&type=script&lang=js"
export * from "./PayoutOpsView.vue?vue&type=script&lang=js"

import "./PayoutOpsView.vue?vue&type=style&index=0&id=528b243a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528b243a"]])

export default __exports__